"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTicketTypeNumberOfAvailableTickets = exports.getTicketTypesByEventId = void 0;
const axios_instance_1 = require("./../axios-instance");
function getTicketTypesByEventId(eventId, noCache = false) {
    return __awaiter(this, void 0, void 0, function* () {
        let url = `/Event/${eventId}/TicketTypes`;
        if (noCache) {
            url += `?t=${Date.now()}`;
        }
        const response = yield axios_instance_1.api.get(url);
        return response.data.ticketTypes;
    });
}
exports.getTicketTypesByEventId = getTicketTypesByEventId;
function getTicketTypeNumberOfAvailableTickets(ticketTypeId, orderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/TicketType/${ticketTypeId}/Availability`, { params: { orderId: orderId } });
        return response.data;
    });
}
exports.getTicketTypeNumberOfAvailableTickets = getTicketTypeNumberOfAvailableTickets;
